function RSVPComplete(props) {
    return (
        <div>
            <div>Thank you for your response! We can't wait to see you!</div>
            <button onClick={ props.reset }>Done</button>
        </div>
    )
}

export default RSVPComplete;